import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import SolsticeLogoutButton from './SolsticeLogoutButton';
import { runningInPortal } from '../utils/IcxPortal';
import { isDevMode } from '../utils';

const SolsticeAppBar = ({ classes, ...props }) => {
  return (
    <AppBar position="static" color="secondary">
      {isDevMode() && !runningInPortal() && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row-reverse',
            minHeight: '54px'
          }}
        >
          <SolsticeLogoutButton />
        </div>
      )}
      <Typography
        variant="h6"
        color="inherit"
        id="react-admin-title"
        data-testid="react-admin-title"
      />
    </AppBar>
  );
};

export default SolsticeAppBar;
